import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=5941d4f2&scoped=true"
import script from "./questions.vue?vue&type=script&lang=js"
export * from "./questions.vue?vue&type=script&lang=js"
import style0 from "./questions.vue?vue&type=style&index=0&id=5941d4f2&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5941d4f2",
  null
  
)

export default component.exports